<template>
  <div class="cargoWarehousingList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            class="list-container"
            :style="{ 'margin-top': menuState == 2 ? '0px' : '10px' }"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="checkBox" v-if="menuState == 2">
              <van-checkbox
                v-model="item.IsChecked"
                @change="handleCheckBox"
              ></van-checkbox>
            </div>
            <div class="container">
              <template v-if="menuState == 4">
                <div class="list-item">
                  {{ $t.cargoWarehousing.mainWbNumber }}：{{ item.PWB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.sideWbNumber }}：{{ item.WB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.returnWarehouse }}：{{ item.WarehouseName }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.cargoWarehousingTime }}：{{
                    item.CargoWarehousingTime
                  }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.consignee }}：{{ item.ConsigneeName }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.consigneePhone }}：{{ item.ConsigneePhone }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.consigneeAddress }}：{{ item.ConsigneeAddress }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.exceptionHandling }}：
                  <span v-if="item.ExceptionHandling == 1">{{
                    $t.cargoWarehousing.eState1
                  }}</span>
                  <span v-if="item.ExceptionHandling == 2">{{
                    $t.cargoWarehousing.eState2
                  }}</span>
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.exceptionReason }}：{{ item.StateName }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.transferDeliveryCount }}：{{
                    item.TransferDeliveryCount
                  }}
                </div>
              </template>
              <template v-else-if="menuState == 3">
                <div class="list-item">
                  {{ $t.cargoWarehousing.outboundBatch }}：{{ item.OutboundBatch }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.mainWbNumber }}：{{ item.PWB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.sideWbNumber }}：{{ item.WB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.outboundTypeLabel }}：
                  <span v-if="item.OutboundType == 1">{{
                    $t.cargoWarehousing.outboundType1
                  }}</span>
                  <span v-if="item.OutboundType == 2">{{
                    $t.cargoWarehousing.outboundType2
                  }}</span>
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.goodsName }}：{{ item.GoodsDescribe }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.orderPiece }}：{{ item.AllBoxNumber }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.deliverer }}：{{ item.DeliveryPerson }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.applyOutboundTime }}：{{
                    item.ApplyOutboundTime
                  }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.isCodorder }}：
                  <span v-if="item.is_codorder">{{ $t.meta.yes }}</span>
                  <span v-else>{{ $t.meta.no }}</span>
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.consignee }}：{{ item.ConsigneeName }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.consigneePhone }}：{{ item.ConsigneePhone }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.pod }}：{{ item.ReceiveCountryCity }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.consigneeAddress }}：{{ item.ConsigneeAddress }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.outBoundState }}：
                  <span v-if="item.OutboundState == 0">{{
                    $t.cargoWarehousing.obState1
                  }}</span>
                  <span v-if="item.OutboundState == 1">{{
                    $t.cargoWarehousing.obState2
                  }}</span>
                  <span v-if="item.OutboundState == 2">{{
                    $t.cargoWarehousing.obState3
                  }}</span>
                  <span v-if="item.OutboundState == 3">{{
                    $t.cargoWarehousing.obState4
                  }}</span>
                </div>
              </template>
              <template v-else>
                <div class="list-item">
                  {{ $t.cargoWarehousing.warehouseEntryNumber }}：{{
                    item.WarehouseEntryNumber
                  }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.mainWbNumber }}：{{ item.PWB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.sideWbNumber }}：{{ item.WB_Number }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.warehouseName }}：{{ item.WarehouseName }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.goodsName }}：{{ item.GoodsDescribe }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.weight }}：{{ item.AllWeight }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.orderPiece }}：{{ item.AllBoxNumber }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.licensePlate }}：{{ item.LicensePlate }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.driverName }}：{{ item.DriverName }}
                </div>
                <div class="list-item" v-if="menuState == 1">
                  {{ $t.cargoWarehousing.driverDeliveryState }}：
                  <span v-if="item.DriverDeliveryState == 0">{{
                    $t.cargoWarehousing.dState1
                  }}</span>
                  <span v-if="item.DriverDeliveryState == 1">{{
                    $t.cargoWarehousing.dState2
                  }}</span>
                  <span v-if="item.DriverDeliveryState == 2">{{
                    $t.cargoWarehousing.dState3
                  }}</span>
                </div>
                <div class="list-item" v-if="menuState == 2">
                  {{ $t.cargoWarehousing.cargoWarehousingTime }}：{{
                    item.CargoWarehousingTime
                  }}
                </div>
                <div class="list-item">
                  {{ $t.cargoWarehousing.warehouseKeeper }}：{{ item.StorageAdminName }}
                </div>
              </template>
              <div class="buttons">
                <van-button
                  class="search-btn"
                  size="small"
                  type="primary"
                  @click="gotoCargoWarehouing('edit', item.ECWId)"
                  v-if="item.WarehouseEntryNumber && menuState == 1"
                  >{{ $t.cargoWarehousing.editTitle }}</van-button
                >

                <van-button
                  class="search-btn"
                  size="small"
                  type="primary"
                  @click="gotoCargoWarehouing('view', item.ECWId)"
                  v-if="item.WarehouseEntryNumber && menuState == 2"
                  >{{ $t.cargoWarehousing.viewTitle }}</van-button
                >

                <van-button
                  class="search-btn"
                  size="small"
                  type="primary"
                  @click="gotoCargoWarehouing('outboundEdit', item.OutboundBatch)"
                  v-if="item.OutboundBatch && menuState == 3"
                  >{{ $t.cargoWarehousing.editOutbound }}</van-button
                >

                <van-button
                  class="danger-btn"
                  size="small"
                  type="primary"
                  @click="gotoException(item.WB_Id)"
                  v-if="menuState == 4"
                >
                  {{ $t.cargoWarehousing.exception1 }}</van-button
                >

                <van-button
                  class="search-btn"
                  size="small"
                  type="primary"
                  @click="gotoRecords(item.WB_Id)"
                  v-if="menuState == 4"
                >
                  {{ $t.cargoWarehousing.exception2 }}</van-button
                >

                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="gotoDetail(item.ECWBId)"
                  >{{ $t.meta.viewDetail }}</van-button
                >
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <template v-if="menuState == 1">
          <div class="radio-label">{{ $t.cargoWarehousing.driverDeliveryState }}</div>
          <van-radio-group v-model="driverDeliveryState" direction="horizontal">
            <van-radio name="1">{{ $t.cargoWarehousing.dState1 }}</van-radio>
            <van-radio name="2">{{ $t.cargoWarehousing.dState2 }}</van-radio>
            <van-radio name="3">{{ $t.cargoWarehousing.dState3 }}</van-radio>
          </van-radio-group>
        </template>

        <template v-if="menuState == 3">
          <div class="radio-label">{{ $t.cargoWarehousing.outBoundState }}</div>
          <van-radio-group v-model="outboundState" direction="horizontal">
            <van-radio name="0">{{ $t.cargoWarehousing.obState1 }}</van-radio>
            <van-radio name="1">{{ $t.cargoWarehousing.obState2 }}</van-radio>
            <van-radio name="2">{{ $t.cargoWarehousing.obState3 }}</van-radio>
            <van-radio name="3">{{ $t.cargoWarehousing.obState4 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.cargoWarehousing.outboundTypeLabel }}</div>
          <van-radio-group v-model="outboundType" direction="horizontal">
            <van-radio name="1">{{ $t.cargoWarehousing.outboundType1 }}</van-radio>
            <van-radio name="2">{{ $t.cargoWarehousing.outboundType2 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.cargoWarehousing.isCodorder }}</div>
          <van-radio-group v-model="isCodOrder" direction="horizontal">
            <van-radio name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </template>

        <template v-if="menuState == 4">
          <div class="radio-label">{{ $t.cargoWarehousing.exceptionHandling }}</div>
          <van-radio-group v-model="exceptionHandling" direction="horizontal">
            <van-radio name="1">{{ $t.cargoWarehousing.eState1 }}</van-radio>
            <van-radio name="2">{{ $t.cargoWarehousing.eState2 }}</van-radio>
          </van-radio-group>
        </template>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar" v-if="menuState == 2">
      <van-button
        type="info"
        block
        :disabled="checkedList.length == 0 ? true : false"
        @click="gotoCargoWarehouing('outbound', null)"
        >{{ $t.cargoWarehousing.applyOutbound }}</van-button
      >
    </div>
  </div>
</template>

<script>
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Checkbox,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox);

export default {
  name: "cargoWarehousingList",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.cargoWarehousing.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.cargoWarehousing.tab2,
          name: 2,
          count: 0,
        },
        {
          title: this.$t.cargoWarehousing.tab3,
          name: 3,
          count: 0,
        },
        {
          title: this.$t.cargoWarehousing.tab4,
          name: 4,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.cargoWarehousing.wbNumber,
          value: 1,
        },
        {
          text: this.$t.cargoWarehousing.warehouseName,
          value: 2,
        },
        {
          text: this.$t.cargoWarehousing.licensePlate,
          value: 3,
        },
        {
          text: this.$t.cargoWarehousing.driverOrStorageName,
          value: 4,
        },
      ],
      showFilter: false,
      driverDeliveryState: null,
      outboundState: null,
      outboundType: null,
      isCodOrder: null,
      exceptionHandling: null,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //多选
      checkedList: [],
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {},
  methods: {
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.IsChecked);
      for (var item of items) {
        list.push({
          ECWBId: item.ECWBId,
          PWB_Number: item.PWB_Number,
          WB_Number: item.WB_Number,
          GoodsDescribe: item.GoodsDescribe,
          AllBoxNumber: item.AllBoxNumber,
          AllWeight: item.AllWeight,
          is_codorder: item.is_codorder,
          ConsigneeName: item.ConsigneeName,
          ConsigneePhone: item.ConsigneePhone,
          ConsigneeAddress: item.ConsigneeAddress,
          IsChecked: true,
        });
      }
      this.checkedList = list;
    },
    gotoCargoWarehouing(type, id) {
      var query = [
        {
          name: "Type",
          value: type,
        },
      ];
      if (type == "edit" || type == "view") {
        query.push({
          name: "ECWId",
          value: id,
        });
      }
      if (type == "outboundEdit") {
        query.push({
          name: "OutboundBatch",
          value: id,
        });
      }
      var data = this.checkedList;
      localStorage.setItem("cargoWarehousing", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoWarehousing",
        name: "cargoWarehousing",
        query: query,
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoWarehousingDetail",
        name: "cargoWarehousingDetail",
        query: [
          {
            name: "ECWBId",
            value: id,
          },
        ],
      });
    },
    gotoRecords(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoWarehousingExceptionRecords",
        name: "cargoWarehousingExceptionRecords",
        query: [
          {
            name: "WB_Id",
            value: id,
          },
        ],
      });
    },
    gotoException(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoWarehousingException",
        name: "cargoWarehousingException",
        query: [
          {
            name: "WB_Id",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.exceptionHandling ||
        this.driverDeliveryState ||
        this.outboundState ||
        this.outboundType ||
        this.isCodOrder ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.beginTime = "";
      this.endTime = "";
      this.driverDeliveryState = null;
      this.outboundState = null;
      this.outboundType = null;
      this.isCodOrder = null;
      this.exceptionHandling = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (this.menuState == 4) {
        this.searchTypeOptions = [
          {
            text: this.$t.cargoWarehousing.wbNumber,
            value: 1,
          },
          {
            text: this.$t.cargoWarehousing.warehouseName,
            value: 2,
          },
        ];
      } else if (this.menuState == 3) {
        this.searchTypeOptions = [
          {
            text: this.$t.cargoWarehousing.wbNumber,
            value: 1,
          },
          {
            text: this.$t.cargoWarehousing.deliveryPersonName,
            value: 2,
          },
        ];
      } else {
        this.searchTypeOptions = [
          {
            text: this.$t.cargoWarehousing.wbNumber,
            value: 1,
          },
          {
            text: this.$t.cargoWarehousing.warehouseName,
            value: 2,
          },
          {
            text: this.$t.cargoWarehousing.licensePlate,
            value: 3,
          },
          {
            text: this.$t.cargoWarehousing.driverOrStorageName,
            value: 4,
          },
        ];
      }
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 1) {
        param.CargoState = 0;
        param.DriverDeliveryState = this.driverDeliveryState;
        param.WaybillNumber = this.searchType == 1 ? this.searchText : "";
        param.WarehouseName = this.searchType == 2 ? this.searchText : "";
        param.LicensePlate = this.searchType == 3 ? this.searchText : "";
        param.DriverOrStorageName = this.searchType == 4 ? this.searchText : "";
        request = this.$api.storage.getCargoWarehousingListByPage(param);
      }
      if (this.menuState == 2) {
        param.CargoState = 1;
        param.WaybillNumber = this.searchType == 1 ? this.searchText : "";
        param.WarehouseName = this.searchType == 2 ? this.searchText : "";
        param.LicensePlate = this.searchType == 3 ? this.searchText : "";
        param.DriverOrStorageName = this.searchType == 4 ? this.searchText : "";
        request = this.$api.storage.getCargoWarehousingListByPage(param);
      }
      if (this.menuState == 3) {
        param.OutboundState = this.outboundState;
        param.OutboundType = this.outboundType;
        param.IsCodOrder = this.isCodOrder;
        param.WaybillNumber = this.searchType == 1 ? this.searchText : "";
        param.DeliveryPerson = this.searchType == 2 ? this.searchText : "";
        request = this.$api.storage.getCargoOutboundListByPage(param);
      }
      if (this.menuState == 4) {
        param.ExceptionHandling = this.exceptionHandling;
        param.WaybillNumber = this.searchType == 1 ? this.searchText : "";
        param.WarehouseName = this.searchType == 2 ? this.searchText : "";
        request = this.$api.storage.getExceptionCargoListByPage(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.cargoWarehousingList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
        .buttons {
          text-align: right;
          .primary-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
